function setupCookieNotice() {
  const notice = document.getElementById("cookie-notice");
  if (!notice) return;
  const KEY = "ps-cookie-consent";
  const stored = localStorage.getItem(KEY);

  function grantConsent() {
    if (window.uetq) {
      window.uetq.push("consent", "update", { ad_storage: "granted" });
    }
  }

  if (stored === "accepted") {
    grantConsent();
  } else if (stored !== "rejected") {
    notice.hidden = false;
  }

  document.getElementById("cookie-accept")?.addEventListener("click", () => {
    localStorage.setItem(KEY, "accepted");
    grantConsent();
    notice.hidden = true;
  });
  document.getElementById("cookie-reject")?.addEventListener("click", () => {
    localStorage.setItem(KEY, "rejected");
    notice.hidden = true;
  });
  document.querySelectorAll(".ps-cookie-settings-btn").forEach((btn) => {
    btn.addEventListener("click", () => {
      notice.hidden = false;
    });
  });
}

function setupHeroRotator() {
  const img = document.getElementById("hero-rotator");
  const dotsWrap = document.getElementById("hero-dots");
  if (!img || !dotsWrap) return;

  let images = [];
  try {
    images = JSON.parse(dotsWrap.dataset.images || "[]");
  } catch (e) {
    images = [];
  }
  if (images.length < 2) return;

  let index = 0;
  dotsWrap.innerHTML = images
    .map((_, i) => `<span class="ps-hero-dot${i === 0 ? " active" : ""}"></span>`)
    .join("");
  const dots = dotsWrap.querySelectorAll(".ps-hero-dot");

  setInterval(() => {
    index = (index + 1) % images.length;
    const nextSrc = images[index];

    const preload = new Image();
    preload.onload = () => {
      img.classList.add("is-fading");
      setTimeout(() => {
        img.src = nextSrc;
        img.classList.remove("is-fading");
      }, 600);
    };
    preload.src = nextSrc;

    dots.forEach((d, i) => d.classList.toggle("active", i === index));
  }, 4500);
}

function setupAddToCart() {
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  document.querySelectorAll('form[data-ps-add]').forEach((form) => {
    const msg = form.querySelector('.ps-add-msg');
    const show = (text) => {
      if (!msg) return;
      msg.textContent = text;
      msg.hidden = !text;
    };
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const btn = form.querySelector('button[type="submit"]');
      show('');
      if (btn) btn.disabled = true;
      try {
        const res = await fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form),
        });
        if (res.ok) {
          window.location.href = root + 'cart';
          return;
        }
        const data = await res.json().catch(() => ({}));
        const abroad = window.Shopify && Shopify.country && Shopify.country !== 'CH';
        show(abroad ? "Nos poêles ne sont livrés qu'en Suisse." : data.description || "Impossible d'ajouter ce produit pour le moment.");
      } catch (err) {
        form.submit();
      } finally {
        if (btn) btn.disabled = false;
      }
    });
  });
}

function setupGallery() {
  const dlg = document.getElementById("ps-lightbox");
  if (!dlg || typeof dlg.showModal !== "function") return;
  const items = [...document.querySelectorAll("[data-ps-zoom]")];
  const img = dlg.querySelector("img");
  let current = 0;
  const show = (n) => {
    current = (n + items.length) % items.length;
    img.src = items[current].href;
    img.alt = items[current].querySelector("img")?.alt || "";
  };
  items.forEach((a, n) =>
    a.addEventListener("click", (e) => {
      e.preventDefault();
      show(n);
      dlg.showModal();
    })
  );
  dlg.querySelector("[data-close]").addEventListener("click", () => dlg.close());
  dlg.querySelector("[data-prev]")?.addEventListener("click", () => show(current - 1));
  dlg.querySelector("[data-next]")?.addEventListener("click", () => show(current + 1));
  dlg.addEventListener("click", (e) => {
    if (e.target === dlg || e.target === img) dlg.close();
  });
  dlg.addEventListener("keydown", (e) => {
    if (e.key === "ArrowLeft") show(current - 1);
    if (e.key === "ArrowRight") show(current + 1);
  });
}

function setupNavToggle() {
  const toggle = document.getElementById("ps-nav-toggle");
  const nav = document.getElementById("ps-main-nav");
  if (!toggle || !nav) return;

  toggle.addEventListener("click", () => {
    const isOpen = nav.classList.toggle("open");
    toggle.setAttribute("aria-expanded", String(isOpen));
  });
  nav.querySelectorAll("a").forEach((link) => {
    link.addEventListener("click", () => nav.classList.remove("open"));
  });
}

function setupPdpGallery() {
  const mainImg = document.getElementById("ps-pdp-main-img");
  if (!mainImg) return;
  document.querySelectorAll("[data-ps-thumb]").forEach((thumb) => {
    thumb.addEventListener("click", () => {
      mainImg.src = thumb.dataset.psThumb;
      document.querySelectorAll("[data-ps-thumb]").forEach((t) => t.classList.remove("active"));
      thumb.classList.add("active");
    });
  });
}

function setupPdpQty() {
  const input = document.getElementById("ps-pdp-qty-input");
  if (!input) return;
  document.getElementById("ps-pdp-qty-minus")?.addEventListener("click", () => {
    input.value = Math.max(1, parseInt(input.value || "1", 10) - 1);
  });
  document.getElementById("ps-pdp-qty-plus")?.addEventListener("click", () => {
    input.value = parseInt(input.value || "1", 10) + 1;
  });
}

document.addEventListener("DOMContentLoaded", () => {
  setupCookieNotice();
  setupHeroRotator();
  setupNavToggle();
  setupAddToCart();
  setupGallery();
  setupPdpGallery();
  setupPdpQty();
});
